
import React from 'react';
import ProductsListView from './ProductsListView';

interface ProductsContentProps {
  products: any[];
  loading: boolean;
  selectedProducts: string[];
  editingProductId: string | null;
  toggleProductSelection: (id: string) => void;
  handleEditProduct: (id: string) => void;
  handleDeleteProduct: (id: string) => void;
  handleBulkDeleteProducts: (ids: string[]) => void;
  handleAddProduct: () => void;
  formatDate: (date: string) => string;
  toggleSelectAll: () => void;
  areAllSelected: boolean;
  fetchProducts: () => Promise<void>;
  addingProduct?: boolean;
  shopId?: string;
}

const ProductsContent = ({
  products,
  loading,
  selectedProducts,
  editingProductId,
  toggleProductSelection,
  handleEditProduct,
  handleDeleteProduct,
  handleBulkDeleteProducts,
  handleAddProduct,
  formatDate,
  toggleSelectAll,
  areAllSelected,
  fetchProducts,
  addingProduct = false,
  shopId
}: ProductsContentProps) => {
  
  return (
    <div className="container mx-auto px-4 py-6 space-y-8 bg-pastel-blue-light dark:bg-[#121624]">
      <ProductsListView
        products={products}
        loading={loading}
        selectedProducts={selectedProducts}
        toggleProductSelection={toggleProductSelection}
        handleEditProduct={handleEditProduct}
        handleDeleteProduct={handleDeleteProduct}
        handleBulkDeleteProducts={handleBulkDeleteProducts}
        handleAddProduct={handleAddProduct}
        formatDate={formatDate}
        toggleSelectAll={toggleSelectAll}
        areAllSelected={areAllSelected}
      />
    </div>
  );
};

export default ProductsContent;
